// extracted by mini-css-extract-plugin
module.exports = {"wrapperRow":"CourierReportComponent_wrapperRow__Y5pPs","wrapperColumn":"CourierReportComponent_wrapperColumn__3uBX_","wrapperAction":"CourierReportComponent_wrapperAction__31Svf"};